export default __webpack_public_path__ + "static/media/email.54d97284.svg";